import Navbar from "../components/Navbar";
import SolutionHeroSection from "../components/SolutionHeroSection";
import SolutionsSection from "../components/SolutionsSection";
import Contact from  "../components/Contact";
import Footer from "../components/Footer";


const Solutions = () => {
  return (
    <>
      <Navbar />
      <SolutionHeroSection />
      <SolutionsSection />
      <Contact />
      <Footer />
    </>
  );
};

export default Solutions;
